/**
 * Kanalzuordnung des Belegungskalenders. In Kalendern und Zeitleisten ist Airbnb sealwax,
 * Booking.com navy, sonstige OTA sage und Manuell amber; die Markentöne `airbnb` und
 * `booking-com` bleiben den Herkunftsabzeichen vorbehalten.
 */

export type ChannelSlug = 'airbnb' | 'booking' | 'otherOta' | 'manual';

export interface ChannelMeta {
  /** Buchstabe im Filter-Cap (A/B/O/M). */
  letter: string;
  /** Lesbares Label für Tooltip/Filter. */
  label: string;
  /** Filter-Slug (lowercase, stabil). */
  slug: ChannelSlug;
  /** Pill-BG-Class (Brand-Token). */
  bgClass: string;
  /** Pill-Text-Class für WCAG-AA-Kontrast. */
  textClass: string;
  /** Filter-Dot im Chip (ohne Text darauf). */
  dotClass: string;
  /** Extra-Classes (z.B. dashed-border für Manuell). */
  extraClass?: string;
}

const CHANNEL_TABLE: Record<ChannelSlug, ChannelMeta> = {
  airbnb: {
    letter: 'A',
    label: 'Airbnb',
    slug: 'airbnb',
    bgClass: 'bg-sealwax',
    textClass: 'text-white',
    dotClass: 'bg-sealwax',
  },
  booking: {
    letter: 'B',
    label: 'Booking.com',
    slug: 'booking',
    bgClass: 'bg-navy',
    textClass: 'text-white',
    dotClass: 'bg-navy',
  },
  otherOta: {
    letter: 'O',
    label: 'Sonstige OTA',
    slug: 'otherOta',
    bgClass: 'bg-sage',
    textClass: 'text-white',
    dotClass: 'bg-sage',
  },
  manual: {
    letter: 'M',
    label: 'Manuell',
    slug: 'manual',
    bgClass: 'bg-amber',
    textClass: 'text-white',
    dotClass: 'bg-amber',
  },
};

export function classifyChannel(channel: string | null | undefined): ChannelMeta {
  if (!channel) return CHANNEL_TABLE.manual;
  const c = channel.toLowerCase();
  if (c.includes('airbnb')) return CHANNEL_TABLE.airbnb;
  if (c.includes('booking')) return CHANNEL_TABLE.booking;
  if (c.includes('manuell') || c.includes('manual')) return CHANNEL_TABLE.manual;
  return CHANNEL_TABLE.otherOta;
}

export const ALL_CHANNELS: ChannelMeta[] = Object.values(CHANNEL_TABLE);
